import React, { ReactElement, useImperativeHandle } from 'react';

interface TrackingEventHandlers {
  onBlur: (...args: any[]) => any;
  onFocus: (...args: any[]) => any;
}

export interface TrackingOptions {
  action: string;
  category: string;
  label?: string;
}

export interface Props {
  children: ReactElement;
  options: TrackingOptions;
  [key: string]: any;
}

const TrackingInput: React.ForwardRefRenderFunction<any, Props> = ({ children, options, ...restProps }, ref) => {
  const inputRef = React.useRef();
  useImperativeHandle(ref, () => inputRef.current!);

  const { onBlur: propOnBlur, onFocus: propOnFocus, ...rest } = restProps;
  const { onBlur: childOnBlur, onFocus: childOnFocus } = (children.props || {}) as TrackingEventHandlers;

  const trackingOnFocus = (event) => {
    if (propOnFocus) {
      propOnFocus(event);
    }
    if (childOnFocus) {
      childOnFocus(event);
    }
  };
  const trackingOnBlur = (event) => {
    if (propOnBlur) {
      propOnBlur(event);
    }
    if (childOnBlur) {
      childOnBlur(event);
    }
  };

  return React.cloneElement(children, {
    ...rest,
    onFocus: trackingOnFocus,
    onBlur: trackingOnBlur,
    ref: inputRef,
  });
};

export default React.forwardRef(TrackingInput);
